// extracted by mini-css-extract-plugin
export default {"skipToContentLink":"src-hellospa-components-skip-to-content-link-skip-to-content-link-module__skipToContentLink--2ziQc"};